import {
  AppBar,
  Avatar,
  Box,
  Button,
  Grid,
  ListItem,
  MenuItem,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { makeStyles } from '@material-ui/styles';
import React, { useState, useEffect } from 'react';
import BreadCrumb from '../../../Components/BreadCrumb';
import { useHistory } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import KenCard from '../../../global_components/KenCard';
import KenTable from '../../../global_components/KenTable/kentable';
import KenInputField from '../../../global_components/KenInputField';
import KenGrid from '../../../global_components/KenGrid';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenDialogBox from '../../../global_components/KenDialogBox';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import Rating from '@material-ui/lab/Rating';
import Autocomplete from '@material-ui/lab/Autocomplete';
import KenPopover from '../../../Components/KenPopOver';
import { green } from '@material-ui/core/colors';
import { List, IconButton } from '@material-ui/core';
import { ArrowDropDownCircleRounded } from '@material-ui/icons';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import Menu from '@material-ui/core/Menu';
import FacultyData from './data.json';
import { RiCheckFill } from 'react-icons/ri';
import KenButton from '../../../global_components/KenButton';
import KenLoader from '../../../Components/KenLoader/index';
import './style.scss';
// import Logo from '../../Assets/ken42-logo.jpg';

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  headerRight: {
    display: 'flex',
    justifyContent: 'end',
  },
  headerBtn: {
    margin: '0 5px',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  popOverData: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#092682',
    fontSize: '12px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  subMenu: {
    top: '28px !important',
    left: '38px !important',
  },
  addBtn: {
    marginTop: '22px',
  },
}));

const cellStyles = makeStyles((theme) => ({
  userBox: {
    display: 'flex',
    alignItems: 'center',
  },
  userBoxText: {
    margin: '0 1em',
    fontSize: 12,
  },
}));

const UserCell = (row, name, popOverOpen) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />{' '}
      {name}
    </p>
  );
};

let a = [];

const FacultyManagement = () => {
  const history = useHistory();
  const classes = useStyles();
  const [anchorSubmenu, setAnchorElSubmenu] = useState(null);
  const openSubmenu = Boolean(anchorSubmenu);
  // const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState([]);
  const [sendBulkEmailDialog, setSendBulkEmailDialog] = useState(false);
  const [sendInviteDialog, setSendInviteDialog] = useState(false);
  const [sendNewInviteDialog, setSendNewInviteDialog] = useState(false);
  const [errorFile, setErrorFile] = useState('');
  const [selectAllData, setSelectAllData] = useState(false);
  const [defaultSelectArray, setDefaultSelectArray] = useState([]);
  const [associationDialog, setAssociationDialog] = useState(false);
  const [startDate, setStartDate] = useState('09/06/2022');
  const [endDate, setEndDate] = useState('29/06/2022');
  const [subjectDialog, setSubjectDialog] = useState(false);
  const [locationDialog, setLocationDialog] = useState(false);
  const [ratingDialog, setRatingDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = React.useState(false);
  // const open = Boolean(anchorEl);
  // const ids = open ? 'simple-popover' : undefined;
  const handleSubmenuClick = (event) => {
    setAnchorElSubmenu(event.currentTarget);
  };
  const handleSubmenuClose = () => {
    handleSendBulkEmailDialog();
  };
  // Subject
  const subjectCells = (rows, item) => {
    return (
      <div
        onClick={(rows) => {
          showSubjectPopup(rows, item);
        }}
        style={{ color: '#242F9B' }}
      >
        {rows}
      </div>
    );
  };
  const showSubjectPopup = (rows, item) => {
    setSubjectDialog(true);
    let data = [];
    data.push(item);
    setSelectedRow(data);
  };
  const subjectDialogCancel = () => {
    setSubjectDialog(false);
    console.log('cancel dialog');
  };
  const subjectDialogSubmit = () => {
    setSubjectDialog(false);
    console.log('submit dialog');
  };
  // Association
  const associationCell = (rows, item) => {
    return (
      <div
        onClick={(rows) => {
          showAssociationPopup(rows, item);
        }}
        style={{ color: '#242F9B' }}
      >
        {rows}
      </div>
    );
  };
  const showAssociationPopup = (rows, item) => {
    setAssociationDialog(true);
    let data = [];
    data.push(item);
    setSelectedRow(data);
  };
  const associationDialogCancel = () => {
    setAssociationDialog(false);
    console.log('cancel dialog');
  };
  const associationDialogSubmit = () => {
    setAssociationDialog(false);
    console.log('submit dialog');
  };
  // Rating
  const ratingCell = (rows, item) => {
    return (
      <div
        onClick={(rows) => {
          showRatingPopup(rows, item);
        }}
        style={{ color: '#242F9B' }}
      >
        {rows}/5
      </div>
    );
  };
  const showRatingPopup = (rows, item) => {
    setRatingDialog(true);
    let data = [];
    data.push(item);
    setSelectedRow(data);
  };
  const ratingDialogCancel = () => {
    setRatingDialog(false);
    console.log('cancel dialog');
  };
  const ratingDialogSubmit = () => {
    setRatingDialog(false);
    console.log('submit dialog');
  };
  // Location
  const locationCell = (rows, item) => {
    return (
      <div
        onClick={(rows) => {
          showLocationPopup(rows, item);
        }}
        style={{ color: '#242F9B' }}
      >
        {rows}
      </div>
    );
  };
  const showLocationPopup = (rows, item) => {
    setLocationDialog(true);
    let data = [];
    data.push(item);
    setSelectedRow(data);
  };
  const locationDialogCancel = () => {
    setLocationDialog(false);
    console.log('cancel dialog');
  };
  const locationDialogSubmit = () => {
    setLocationDialog(false);
    console.log('submit dialog');
  };

  // const handlePopoverOpen = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handlePopoverClose = () => {
  //   setAnchorEl(null);
  // };
  const newArrayEmail = data.map((e) => {
    console.log('data------>', e.name.props.children[2]);
    return { title: e.name.props.children[2], year: 1997 };
    // { title: 'Jane Coper', year: 1994 },
  });
  const inviteEmail = data.map((e) => {
    return { title: e.name.props.children[2], year: 1997 };
  });
  const [newInviteEmail, setNewInviteEmail] = useState([
    { title: '', year: 1997 },
  ]);

  const filesFormats = [
    '.doc',
    'image/jpeg',
    'image/jpg',
    'image/png',
    '.docx',
    'application/pdf',
  ];
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const handleSelectRow = (evt, row, index) => {
    let uniqueArr = [];
    a.push({ title: row.name.props.children[2], year: 1997 });
    a.sort(dynamicSort('title'));
    for (let i = 0; i < a.length; i++) {
      let aw = a[i + 1] ? a[i + 1].title : '';
      if (a[i].title == aw) {
        i++;
      } else {
        uniqueArr.push(a[i]);
      }
    }
    console.log('uuuu', uniqueArr);
    // for (let i = 0; i < a.length; i++) {
    //   if (a[i]?.title == a[i + 1]?.title) {
    //     i++;
    //   } else {
    //     uniqueArr.push(a[i]);
    //   }
    // }
    setDefaultSelectArray(uniqueArr);
  };
  const fileValidation = (e) => {
    console.log('eee', e);
    const isRightFormat = filesFormats.includes(e.type);
    console.log('isRightFormat', isRightFormat);
    if (isRightFormat === false) {
      setErrorFile('Please Select Only Doc ,Pdf and Image');
    } else {
      setErrorFile('');
    }
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  /**
   * @desc Handles Open and close of send bulk email dialog box
   */
  function handleSendBulkEmailDialog() {
    setAnchorElSubmenu(null);
    setSendBulkEmailDialog((prevState) => !prevState);
  }

  function handleSendInviteDialog() {
    setSendInviteDialog((prevState) => !prevState);
  }
  function handleSendNewInviteDialog() {
    setSendNewInviteDialog((prevState) => !prevState);
  }
  const workload = [
    {
      label: 'Invite Email',
      value: 'Invite Email',
    },
    {
      label: 'Faculty Contract',
      value: 'Faculty Contract',
    },
    {
      label: 'Faculty workload form',
      value: 'Faculty workload form',
    },
  ];
  const handleChangedDate = (e) => {
    console.log('time', e.target.value);
  };
  React.useEffect(() => {
    setLoading(true);
    const tableData = [];
    const data = FacultyData['Faculty Invitation'];
    data.map((item) => {
      tableData.push({
        name: UserCell(item.img, item.name),
        phone: item.phone,
        email: item.email,
        location: locationCell(item.location, item),
        association: item.association,
        availability: associationCell(item.availability, item),
        subjects: subjectCells(item.subjects, item),
        rating: ratingCell(item.rating, item),
      });
    });
    setData(tableData);
    setLoading(false);
  }, []);

  return (
    <Box>
      {loading && <KenLoader />}
      {/* Buttons */}
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Grid container justifyContent="space-between">
            <Grid item className={classes.headerLeft}>
              <Typography variant="h6" className={classes.title}>
                Faculty Invitation
              </Typography>
            </Grid>
            <Grid item className={classes.headerRight}>
              <Button
                startIcon={<MailOutlineIcon />}
                variant="contained"
                color="primary"
                aria-controls={openSubmenu ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openSubmenu ? 'true' : undefined}
                onClick={handleSendNewInviteDialog}
                className={classes.headerBtn}
                name="Send New Invite"
              >
                Send New Invite
              </Button>
              <Button
                startIcon={<MailOutlineIcon />}
                variant="contained"
                color="primary"
                aria-controls={openSubmenu ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openSubmenu ? 'true' : undefined}
                onClick={handleSendInviteDialog}
                className={classes.headerBtn}
                name="Send Invite"
              >
                Send Invite
              </Button>
              <Button
                startIcon={<MailOutlineIcon />}
                variant="contained"
                color="primary"
                aria-controls={openSubmenu ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openSubmenu ? 'true' : undefined}
                onClick={handleSendBulkEmailDialog}
                className={classes.headerBtn}
                name="Send Email"
              >
                Send Email
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {/* Table */}
      <Box className="cardlsitbox">
        <KenCard elevation={0}>
          {data.length > 0 ? (
            <div className="faculty-invite-table">
              <KenTable
                data={data}
                rowClick={(item) => {
                  return null;
                }}
                allcheckboxData={(state) => handleSelectAllRows(state)}
                onRowCheckBox={(event, row, index) =>
                  handleSelectRow(event, row, index)
                }
              />
            </div>
          ) : null}
        </KenCard>
      </Box>
      {/* Send Bulk-Mail */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Email
          </Typography>
        }
        open={sendBulkEmailDialog}
        handleClose={() => handleSendBulkEmailDialog()}
        negativeButtonClick={() => handleSendBulkEmailDialog()}
        positiveButtonClick={() => handleSendBulkEmailDialog()}
        positiveButtonText="Send"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="size-small-outlined"
              size="large"
              options={newArrayEmail}
              getOptionLabel={(option) => option.title}
              defaultValue={defaultSelectArray}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=""
                  placeholder="Enter faculty name"
                />
              )}
            />
          </Grid>
          {/* <Grid item xs={12} sm={12}>
            <KenSelectWrap
              label="Send faculty workload form"
              options={workload}
              dropdownColor="#FFFFFF"
            />
          </Grid> */}
          <Grid item xs={12} sm={12}>
            <KenInputField label="Subject" required />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              id="outlined-email-input"
              label="Body"
              multiline
              rows="10"
              className={classes.textField}
              type="text"
              name="subject"
              // autoComplete="email"
              margin="normal"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <KenInputField
              label="Attachment"
              type="file"
              onChange={(e) => fileValidation(e.target.files[0])}
              required
            />
            <p style={{ color: 'red' }}>{errorFile}</p>
          </Grid>
        </Grid>
      </KenDialogBox>
      {/* Send Invite */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Invite
          </Typography>
        }
        open={sendInviteDialog}
        handleClose={() => handleSendInviteDialog()}
        negativeButtonClick={() => handleSendInviteDialog()}
        positiveButtonClick={() => handleSendInviteDialog()}
        positiveButtonText="Send"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="size-small-outlined"
              size="large"
              options={inviteEmail}
              getOptionLabel={(option) => option.title}
              defaultValue={inviteEmail}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=""
                  placeholder="Enter faculty name"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <KenInputField label="Subject" required />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              id="outlined-email-input"
              label="Body"
              multiline
              rows="10"
              className={classes.textField}
              type="text"
              name="subject"
              // autoComplete="email"
              margin="normal"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <KenInputField
              label="Attachment"
              type="file"
              onChange={(e) => fileValidation(e.target.files[0])}
              required
            />
            <p style={{ color: 'red' }}>{errorFile}</p>
          </Grid>
        </Grid>
      </KenDialogBox>
      {/* Send New Invite */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send New Invite
          </Typography>
        }
        open={sendNewInviteDialog}
        handleClose={() => handleSendNewInviteDialog()}
        negativeButtonClick={() => handleSendNewInviteDialog()}
        positiveButtonClick={() => handleSendNewInviteDialog()}
        positiveButtonText="Send"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="size-small-outlined"
              size="large"
              options={newInviteEmail}
              getOptionLabel={(option) => option.title}
              defaultValue={newInviteEmail}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=""
                  placeholder="Enter faculty name"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <KenInputField label="Subject" required />
          </Grid>

          <Grid item xs={12} sm={12}>
            <TextField
              id="outlined-email-input"
              label="Body"
              multiline
              rows="10"
              className={classes.textField}
              type="text"
              name="subject"
              // autoComplete="email"
              margin="normal"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <KenInputField
              label="Attachment"
              type="file"
              onChange={(e) => fileValidation(e.target.files[0])}
              required
            />
            <p style={{ color: 'red' }}>{errorFile}</p>
          </Grid>
        </Grid>
      </KenDialogBox>
      {/* Association Popup */}
      <div className="faculty-mgmt-div">
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Availability
            </Typography>
          }
          open={associationDialog}
          icon={<RiCheckFill />}
          handleClose={() => associationDialogCancel()}
          negativeButtonClick={() => associationDialogCancel()}
          positiveButtonClick={() => associationDialogSubmit()}
          positiveButtonText="Ok"
          negativeButtonText="Cancel"
          style={{ width: '80%' }}
          dividers
        >
          {selectedRow[0]?.association === 'Visiting' ? (
            <>
              <Typography>
                <b style={{ fontSize: '20px' }}>
                  {selectedRow[0]?.designation} {selectedRow[0]?.name}
                </b>
              </Typography>
              <Grid container xs={12} style={{ marginTop: '10px' }}>
                {selectedRow[0]?.visit.map((item) => {
                  return (
                    <Grid container xs={12}>
                      <Grid xs={3} style={{ marginRight: '10px' }}>
                        <KenDateTimePicker
                          name={'startDate'}
                          label="Start Date"
                          value={item.startDate}
                          type="date"
                          required={true}
                          disabled={true}
                        />
                      </Grid>
                      <Grid xs={3} style={{ marginRight: '10px' }}>
                        <KenDateTimePicker
                          name={'endDate'}
                          label="End Date"
                          value={item.endDate}
                          type="date"
                          required={true}
                          disabled={true}
                        />
                      </Grid>
                      <Grid style={{ marginRight: '10px' }}>
                        <KenDateTimePicker
                          name={'startTime'}
                          label="Start Time"
                          value={item.startTime}
                          type="time"
                          required={true}
                          disabled={true}
                        />
                      </Grid>
                      <Grid>
                        <KenDateTimePicker
                          name={'endTime'}
                          label="End Time"
                          value={item.endTime}
                          type="time"
                          required={true}
                          disabled={true}
                        />
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </>
          ) : (
            <>
              <Typography>
                <b style={{ fontSize: '20px' }}>
                  {selectedRow[0]?.designation} {selectedRow[0]?.name}
                </b>
              </Typography>
              <Grid container xs={12} style={{ marginTop: '10px' }}>
                <Grid xs={3}>
                  <Typography>Available Days</Typography>
                </Grid>
                <Grid xs={8}>
                  <Typography>
                    <b>Monday - Friday</b>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container xs={12}>
                <Grid xs={3}>
                  <Typography>Available Time</Typography>
                </Grid>
                <Grid xs={8}>
                  <Typography>
                    <b>8:30 AM - 5:30 PM</b>
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
        </KenDialogBox>
      </div>
      {/* Subject Popup */}
      <div className="faculty-mgmt-div">
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Subjects
            </Typography>
          }
          open={subjectDialog}
          icon={<RiCheckFill />}
          handleClose={() => subjectDialogCancel()}
          negativeButtonClick={() => subjectDialogCancel()}
          positiveButtonClick={() => subjectDialogSubmit()}
          positiveButtonText="Ok"
          negativeButtonText="Cancel"
          style={{ width: '80%' }}
          dividers
        >
          {/* Subject Data */}
          <Typography>
            <b style={{ fontSize: '20px' }}>
              {selectedRow[0]?.designation} {selectedRow[0]?.name}
            </b>
          </Typography>
          {selectedRow.length > 0 ? (
            selectedRow[0]?.subject.map((item, index) => {
              return (
                <Typography>
                  {index + 1}
                  {'. '}
                  {item.label}
                </Typography>
              );
            })
          ) : (
            <></>
          )}
        </KenDialogBox>
      </div>
      {/* Rating Popup */}
      <div className="faculty-mgmt-div">
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Rating
            </Typography>
          }
          open={ratingDialog}
          icon={<RiCheckFill />}
          handleClose={() => ratingDialogCancel()}
          negativeButtonClick={() => ratingDialogCancel()}
          positiveButtonClick={() => ratingDialogSubmit()}
          positiveButtonText="Ok"
          negativeButtonText="Cancel"
          style={{ width: '80%' }}
          dividers
        >
          {/* Rating Data */}
          <Typography>
            <b style={{ fontSize: '20px' }}>
              {selectedRow[0]?.designation} {selectedRow[0]?.name}
            </b>
          </Typography>
          <Grid container xs={12} style={{ marginTop: '10px' }}>
            {selectedRow.length > 0 ? (
              selectedRow[0]?.subject.map((item, index) => {
                return (
                  <>
                    <Grid xs={5}>
                      <Typography>
                        {index + 1}
                        {'. '}
                        {item.label}
                      </Typography>
                    </Grid>
                    <Grid xs={5}>
                      <Typography>
                        <b>{item.batch}</b>
                      </Typography>
                    </Grid>
                    <Grid xs={2}>
                      <Rating
                        name="rating"
                        defaultValue={item.rating}
                        precision={0.5}
                        disabled={true}
                        size="small"
                      />
                      {item.rating}/5
                    </Grid>
                  </>
                );
              })
            ) : (
              <></>
            )}
          </Grid>
        </KenDialogBox>
      </div>
      {/* Location Popup */}
      <div className="faculty-mgmt-div">
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Location
            </Typography>
          }
          open={locationDialog}
          icon={<RiCheckFill />}
          handleClose={() => locationDialogCancel()}
          negativeButtonClick={() => locationDialogCancel()}
          positiveButtonClick={() => locationDialogSubmit()}
          positiveButtonText="Ok"
          negativeButtonText="Cancel"
          style={{ width: '80%' }}
          dividers
        >
          {/* Subject Data */}
          <Typography>
            <b style={{ fontSize: '20px' }}>
              {selectedRow[0]?.designation} {selectedRow[0]?.name}
            </b>
          </Typography>
          <Typography>Current Location: {selectedRow[0]?.location}</Typography>
          <Typography>
            Location Preference:{' '}
            {selectedRow[0]?.locationPreference.map((item, index) => (
              <>
                <p style={{ margin: '0px 10px' }}>
                  {index + 1}. {item}
                </p>{' '}
              </>
            ))}
          </Typography>
        </KenDialogBox>
      </div>
    </Box>
  );
};

export default FacultyManagement;
